(function(){
     'use strict';

     angular
        .module('app')
        .factory('DashboardService', DashboardService);

    DashboardService.$inject = ['$http'];

    function DashboardService($http){


        var service= {
            saveDash: saveDash,
            getDashboards:getDashboards,
            removeDash:removeDash
        };

        return service;




        function getDashboards(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
            });
            $http.post('/backend/altcrm/site/getmydashboard', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function saveDash(cuadro,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
                cuadro:JSON.stringify(cuadro)
            });
            $http.post('/backend/altcrm/site/savedash', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function removeDash(cuadro,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
                cuadro:JSON.stringify(cuadro)
            });
            $http.post('/backend/altcrm/site/removedash', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

    }
})();